module.exports = __webpack_public_path__ + "static/media/Cross.222a47e3.svg";